import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line import/extensions
import { BsGearFill } from 'react-icons/bs';
import { yellow } from '../../styles/standard-colors.js';

/**
 * SettingsGear component for displaying a settings gear button with optional navigation or onClick functionality.
 *
 * @component
 * @example
 * // Example usage with navigation:
 * <SettingsGear navigateTo="/add-item" color="blue" size={40} />
 *
 * @example
 * // Example usage with custom onClick:
 * <SettingsGear onClick={() => handleAddButtonClick()} size={30} />
 *
 * @param {Object} props - The component props.
 * @param {string} [props.color='#FF355E'] - The color of the button. Defaults to yellow.
 * @param {number} [props.size=34] - The size of the button icon.
 * @param {string} [props.navigateTo] - The URL to navigate to when the button is clicked.
 * @param {Function} [props.onClick] - The function to be executed when the button is clicked.
 *
 * @returns {JSX.Element} - The rendered SettingsGear component.
 */
const SettingsGear = ({ color, size, navigateTo, onClick }) => {
    const navigate = useNavigate();

    if (navigateTo) {
        return (
            <BsGearFill
                size={size}
                color={color}
                style={{ cursor: 'pointer', marginLeft: '2em' }}
                onClick={() => navigate(navigateTo)}
            />
        );
    }

    if (onClick) {
        return (
            <BsGearFill
                size={size}
                color={color}
                style={{ cursor: 'pointer', marginLeft: '2em' }}
                onClick={onClick}
            />
        );
    }

    return (
        <BsGearFill size={size} color={color} style={{ marginLeft: '2em' }} />
    );
};

SettingsGear.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
    navigateTo: PropTypes.string,
    onClick: PropTypes.func
};

SettingsGear.defaultProps = {
    color: yellow,
    size: 34
};

export default SettingsGear;
